import { createSelector } from '@ngrx/store';
import { OptionState } from '../../../../../models';
import { createFilterStateSelector } from '../create-filter-state-selector/create-filter-state.selector';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const createCheckedOptionsSelector = (filterInstanceId: string) =>
  createSelector(createFilterStateSelector(filterInstanceId), (filterState) => {
    if (!filterState?.fieldsState) {
      return null;
    }

    return Object.values(filterState.fieldsState).reduce((result, currentField) => {
      result[currentField.id] = Object.values(currentField.options).filter((option) => option.isChecked).reduce((options, currentOption) => {
        options[currentOption.id] = currentOption;
        return options;
      }, {});
      return result;
    }, {}) as { [fieldId: string]: { [optionId: string]: OptionState } };
  });
